import {Component, forwardRef} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {FUIAlertService, FUIModalsService, FUISpinnersService} from "@fedeltapointofsale/ui";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {CategoryMoveAction, CategoryMoveService} from "../category-move.service";
import {CategoryMoveModalComponent} from "./category-move-modal.component";

/**
 * SearchAction to move a category to another parent
 */
@Component({
    selector: "wbo-category-move-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => CategoryMoveSearchActionComponent),
            multi: true
        },
        CategoryMoveService
    ]

})
export class CategoryMoveSearchActionComponent implements SearchAction {

    constructor(private alertService: FUIAlertService,
                private searchModel: SearchModel<any>,
                private service: CategoryMoveService,
                private modalsService: FUIModalsService,
                private spinnersService: FUISpinnersService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 1;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "folder";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.category.search.action.moveCategory";
    }

    async doAction(data: any): Promise<void> {
        const modal: CategoryMoveModalComponent = await this.modalsService.create(CategoryMoveModalComponent).toPromise();
        modal.category = data;
        return new Promise((resolve) => {
            modal.onConfirm.subscribe(async (targetCategory) => {
                await this.spinnersService.open();
                try {
                    await this.service.performAction(new CategoryMoveAction(data.categoryId, targetCategory));
                    resolve();
                } finally {
                    await this.spinnersService.close();
                }
            });
        });
    }

    isAvailable(data: any): boolean {
        return true;
    }
}
